import React, { useState, useEffect } from "react"

import Button from 'components/forms/button/Button'
// import ProductItem from './c/ProductItem/ProductItem'

import { ReactComponent as MenuSvg } from 'resources/icons/general/menu_pt1.svg'
import { ReactComponent as CrossSvg } from 'resources/icons/general/cross_pt1.svg'

import * as st from './Header.styled.js'

const BORDERED_SCROLL_Y = 42

const Header = ({
  isOpenMobileMenu,
  onToggleMobileMenu,
}) => {
  const [isBordered, setBordered] = useState(false)

  useEffect(() => {
    setBordered(window.scrollY > BORDERED_SCROLL_Y)
    const handleScroll = () => setBordered(window.scrollY > BORDERED_SCROLL_Y)

    window.addEventListener('scroll', handleScroll)

    return () => window.removeEventListener('scroll', handleScroll)
  }, [])

  return (
    <st.Wrap>
      <st.BluredBackdrop />
      <st.Content isBordered={isBordered}>
        <st.LogoMenuSection>
          <st.LogoLink to="/">
            <st.Logo
              src="//cdn-platform.scope-dev.ws/website/images/logos/scope-on-light-32.png"
              srcSet="//cdn-platform.scope-dev.ws/website/images/logos/scope-on-light-32.png 1x, //cdn-platform.scope-dev.ws/website/images/logos/scope-on-light-32@2x.png 2x"
              width={130}
              height={32}
              alt="Scope"
            />
          </st.LogoLink>
          <st.MainMenu>
            {/* <ProductItem /> */}
            <Button
              type="link"
              size={600}
              view="simple"
              href="/pricing"
            >
              Pricing
            </Button>
            <Button
              type="link"
              size={600}
              view="simple"
              href="/changelog"
            >
              Product updates
            </Button>
          </st.MainMenu>
        </st.LogoMenuSection>
        <st.MobileMenuButton
          view="simple"
          size={600}
          icon={isOpenMobileMenu ? CrossSvg : MenuSvg}
          onClick={onToggleMobileMenu}
        />
        <st.SignInUpSection>
          <Button
            type="a"
            size={600}
            view="secondary"
            href="https://scope.ws/sign-in"
          >
            Sign In
          </Button>
          <Button
            type="a"
            size={600}
            view="primary"
            href="https://cal.com/scope/demo"
            eventName="book-demo"
          >
            Book a Demo
          </Button>
        </st.SignInUpSection>
      </st.Content>
    </st.Wrap>
  )
}

export default Header
